module.exports = __webpack_public_path__ + "static/media/nicolas.2ca30b1d.jpeg";